import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=2beec239&scoped=true"
import script from "./OrganizationChart.vue?vue&type=script&lang=js"
export * from "./OrganizationChart.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChart.vue?vue&type=style&index=0&id=2beec239&prod&lang=scss&scoped=true"
import style1 from "./OrganizationChart.vue?vue&type=style&index=1&id=2beec239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beec239",
  null
  
)

export default component.exports